import { render, staticRenderFns } from "./RemovalMenuComponent.vue?vue&type=template&id=710c9e8e&scoped=true&"
import script from "./RemovalMenuComponent.vue?vue&type=script&lang=js&"
export * from "./RemovalMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./RemovalMenuComponent.vue?vue&type=style&index=0&id=710c9e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c9e8e",
  null
  
)

export default component.exports